import { create } from 'zustand';

/**
 * 우측 고정 메뉴바(메모 아래)에 놓일 **현재 채팅방 카드**를 채팅 화면이 올려두는 자리.
 *
 * 레일은 전역 호스트(RightRailHost)가 그리고 채팅방 정보는 채팅 화면만 안다. 레일이 채팅을
 * 직접 import 하면 전역이 한 화면에 묶이므로, 채팅이 여기에 요약만 올려두고 레일이 읽어 간다.
 *
 * persist 하지 않는다 — 지금 보고 있는 방을 가리키는 값이라 새로고침 후 남아 있으면 거짓말이 된다.
 * 채팅 화면을 벗어나면 `clear()` 로 비워 다른 화면의 레일이 깨끗하게 유지된다.
 */
export interface ChatRoomRailInfo {
  roomId: string;
  name: string;
  memberCount: number;
}

interface ChatRoomRailState {
  info: ChatRoomRailInfo | null;
  /** 패널이 열려 있는가 — 카드의 강조 표시에 쓴다. */
  panelOpen: boolean;
  /** 카드를 누르면 실행할 동작(패널 열기/닫기) — 채팅 화면이 심는다. */
  onToggle: (() => void) | null;
  publish: (info: ChatRoomRailInfo, panelOpen: boolean, onToggle: () => void) => void;
  clear: () => void;
}

export const useChatRoomRailStore = create<ChatRoomRailState>((set) => ({
  info: null,
  panelOpen: false,
  onToggle: null,
  publish: (info, panelOpen, onToggle) => set({ info, panelOpen, onToggle }),
  clear: () => set({ info: null, panelOpen: false, onToggle: null }),
}));
